import { render, staticRenderFns } from "./BoundAccount.vue?vue&type=template&id=20a74c57&scoped=true&"
import script from "./BoundAccount.vue?vue&type=script&lang=js&"
export * from "./BoundAccount.vue?vue&type=script&lang=js&"
import style0 from "./BoundAccount.vue?vue&type=style&index=0&id=20a74c57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a74c57",
  null
  
)

/* custom blocks */
import block0 from "./BoundAccount.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports